import { useEffect } from 'react';

/**
 * Feeds the cursor position into every `.spotlight` element as --sx/--sy,
 * which index.css uses for the glow that follows the cursor on hover.
 */
export function useSpotlight() {
  useEffect(() => {
    if (!window.matchMedia?.('(pointer: fine)').matches) return;

    let frame = 0;
    let x = 0;
    let y = 0;

    const update = () => {
      frame = 0;
      document.querySelectorAll<HTMLElement>('.spotlight').forEach((el) => {
        const rect = el.getBoundingClientRect();
        el.style.setProperty('--sx', `${x - rect.left}px`);
        el.style.setProperty('--sy', `${y - rect.top}px`);
      });
    };

    const onMove = (e: PointerEvent) => {
      x = e.clientX;
      y = e.clientY;
      if (!frame) frame = requestAnimationFrame(update);
    };

    window.addEventListener('pointermove', onMove, { passive: true });
    return () => {
      window.removeEventListener('pointermove', onMove);
      cancelAnimationFrame(frame);
    };
  }, []);
}
